"use client";
import { StandardProps } from "../../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { isAvailableToOrder } from "@/utils/product/isAvailableToOrder.ts";
import { GridGalleryUI } from "./GridGalleryUI";
import { GalleryContextProvider } from "./GridGalleryContext";

type GalleryProps = Pick<
  StandardProps,
  "product" | "configProps" | "flags" | "experiencesRawObject"
> & {
  sizes: string;
  configProps?: {
    SocialProofMessages?: {
      appId: string;
      withClose?: boolean;
    };
    pdpAsLanding?: boolean;
  };
};

export const GridGallery = ({
  product,
  sizes,
  configProps,
  flags,
  experiencesRawObject,
}: GalleryProps) => {
  const { variant } = useVariant(product);

  const pdpAsLanding = configProps?.pdpAsLanding === true;

  if (!variant) return null;

  const media = "media" in product ? product.media : null;

  const videos = media?.videos || [];

  const title = variant.title;

  const images = variant.images;

  const socialProofMessagesProperties =
    product.__typename === "SimpleProduct" && configProps?.SocialProofMessages
      ? {
          ...configProps.SocialProofMessages,
          productId: product.aliases.pimProductId,
          brand: product.brand.name,
          availableToOrder: isAvailableToOrder(product),
          experiencesRawObject,
        }
      : undefined;

  return (
    <GalleryContextProvider
      product={product}
      enableAnalytics={configProps?.enableAnalytics === true}
      selectedVariant={variant}
    >
      <GridGalleryUI
        title={title}
        images={images}
        videos={videos}
        sizes={sizes}
        hasSocialProofMessagesExperience={true}
        socialProofMessagesProperties={socialProofMessagesProperties}
        hasSuperZoom={!flags.isSuperZoomDisabled.value}
        isCondensed={!!flags.condensedGallery.value}
        usePrefetching={!!flags.usePrefetching.value}
        showThumbnailsOnMobile={!!flags.showThumbnailsOnMobile.value}
        showPeeks={!!flags.showPeeks.value}
        useResponsiveImages={!!flags.useResponsiveImages.value}
        pdpAsLanding={pdpAsLanding}
      />
    </GalleryContextProvider>
  );
};
